var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSidebarExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08332 6.75V9.25C5.08332 9.66422 4.78952 10 4.42707 10H1.65625C1.29381 10 1 9.66422 1 9.25V6.75C1 6.33578 1.29381 6 1.65625 6H4.42707C4.78952 6 5.08332 6.33578 5.08332 6.75ZM1 11.75V14.25C1 14.6642 1.29381 15 1.65625 15H4.42707C4.78952 15 5.08332 14.6642 5.08332 14.25V11.75C5.08332 11.3358 4.78952 11 4.42707 11H1.65625C1.29381 11 1 11.3358 1 11.75ZM4.42707 1H1.65625C1.29381 1 1 1.33578 1 1.75V4.25C1 4.66422 1.29381 5 1.65625 5H4.42707C4.78952 5 5.08332 4.66422 5.08332 4.25V1.75C5.08332 1.33578 4.78952 1 4.42707 1ZM6.91207 15H14.3438C14.7062 15 15 14.6642 15 14.25V11.75C15 11.3358 14.7062 11 14.3438 11H6.91207C6.54962 11 6.25582 11.3358 6.25582 11.75V14.25C6.25582 14.6642 6.54962 15 6.91207 15ZM6.25582 1.75V4.25C6.25582 4.66422 6.54962 5 6.91207 5H14.3438C14.7062 5 15 4.66422 15 4.25V1.75C15 1.33578 14.7062 1 14.3438 1H6.91207C6.54962 1 6.25582 1.33578 6.25582 1.75ZM6.91207 10H14.3438C14.7062 10 15 9.66422 15 9.25V6.75C15 6.33578 14.7062 6 14.3438 6H6.91207C6.54962 6 6.25582 6.33578 6.25582 6.75V9.25C6.25582 9.66422 6.54962 10 6.91207 10Z",
    fill: "#A8ADBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidebarExplore);
export default __webpack_public_path__ + "static/media/ic-sidebar-explore.07d65fa7c768b3bcd9fdade55572cbfe.svg";
export { ForwardRef as ReactComponent };